<template>
  <div>
    <v-dialog :value="true" scrollable persistent :max-width="maxWidth">
      <v-card>
        <v-card-title class="primary modal-title py-0">
          <span>Responder
            <span v-if="ehRecurso"> Recurso</span>
            <span v-else> Contrarrazão</span>
          </span>
          <v-spacer/>
          <v-btn icon @click="fecharModal">
            <v-icon size="20" color="white">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="overflow-x: hidden">
          <v-layout row wrap>
            <v-flex xs4 sm4 d-flex>
              <campo-apresentacao labelPadrao="Licitante" :text="dadosRecursoContrarrazao.fornecedor.razaoSocial"/>
            </v-flex>
            <v-flex xs4 sm4 d-flex>
              <div class="az-text px-1">
                <label class="label">Envio</label>
                <div>{{dadosRecursoContrarrazao.dataEnvio | azDate('DD/MM/YYYY HH:mm')}}</div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex class="pb-2">
              <p class="text-campo" style="margin-bottom: 5px">Tipos</p>
              <span>
                <v-chip v-for="lote in dadosRecursoContrarrazao.lotes">{{lote.descricao}}</v-chip>
              </span>
            </v-flex>
          </v-layout>
          <p class="text-campo pb-1" style="margin-top: 4px">Conteúdo
            <span v-if="ehRecurso">Recurso</span>
            <span v-else>Contrarrazão</span></p>
          <div class="pb-3">{{dadosRecursoContrarrazao.conteudo}}</div>
          <div>
            <p class="text-campo pb-1" style="margin-bottom: 4px">Anexos</p>
            <a v-for="anexo in dadosRecursoContrarrazao.anexos" :href="criarLinkDownloadTemporario(anexo.uri)" class="link-sem-decoracao">
              <v-chip class="mx-1" small>
                {{anexo.nome}}<v-icon class="ml-1">get_app</v-icon>
              </v-chip>
            </a>
          </div>
          <p class="text-campo" style="margin-top: 4px">Conteúdo Resposta
          <span class="ml-1 red--text">*</span>
          <span class="ml-1 red--text" v-if="limiteTextoAtingido">Limite máximo de caracteres atingido!</span></p>
          <v-textarea rows="2" auto-grow class="textarea-conteudo-recurso required-field" placeholder="Informe o conteúdo..." v-model="dadosGeraisResposta.conteudo" v-on:keyup="contarTamanhoTexto" counter/>
          <div>
            <p class="text-campo" style="margin-bottom: 4px">Anexos</p>
            <licitacao-recurso-contrarrazao-anexo style="margin-top: -25px" :dadosRecursoContrarrazao="dadosGeraisResposta"/>
          </div>
        </v-card-text>
        <div class="az-actions-form actions-modal">
          <button class="action-secundary-button" @click="fecharModal">Cancelar</button>
          <button v-if="dadosGeraisResposta.conteudo && dadosGeraisResposta.conteudo.trim()" class="action-primary-button"
                  @click.prevent="confirmarResposta">
            Enviar Resposta
          </button>
          <div v-else>
            <v-tooltip top nudge-top="10" max-width="250">
              <template v-slot:activator="{ on }">
                <button v-on="on" class="action-primary-button-disabled btn-disabled">Enviar Resposta</button>
              </template>
              É necessário preencher o conteúdo da resposta para continuar.
            </v-tooltip>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <modal-confirmar-etapa-anexo
        v-model="modalConfirmarEnvio"
        :title="'Confirmar Envio'"
        :max-width="'450'"
        :text="mensagemConfirmacao"
        second-text="Esta ação NÃO PODERÁ ser desfeita!"
        @fecharModalConfirm="naoContinuarSemAnexo"
        @cancelarAcao="naoContinuarSemAnexo"
        @confirmarAcao="enviarResposta"
    />
  </div>
</template>
<script>
import CampoApresentacao from '@/commons/components/campos/campo-apresentacao.vue'
import LicitacaoRecursoAnexo
  from "@/views/licitacao/detalhe/orgao/recursocontrarrazao/LicitacaoRecursoContrarrazaoAnexo.vue";
import LicitacaoRecursoContrarrazaoAnexo
  from "@/views/licitacao/detalhe/orgao/recursocontrarrazao/LicitacaoRecursoContrarrazaoAnexo.vue";
import ModalConfirmarEtapaAnexo from "@/commons/components/ModalConfirmarEtapaAnexo.vue";
import {tipoRecursoContrarrazao} from "@/commons/constants";

export default {
  name: 'ModalResponderRecursoContrarrazao',
  components: {
    ModalConfirmarEtapaAnexo, LicitacaoRecursoContrarrazaoAnexo,
    LicitacaoRecursoAnexo, CampoApresentacao
  },
  props: {
    tipoResposta:{
      type: String,
      default: tipoRecursoContrarrazao.RECURSO
    },
    dadosLicitacao: {
      type: Object,
      default: null
    },
    dadosRecursoContrarrazao:{
      type: Object,
      default: null
    },
    maxWidth: {
      type: String,
      default: '800'
    },
  },
  data() {
    return {
      modalConfirmarEnvio:false,
      limiteTextoAtingido: false,
      maxTextArea: 1000,
      totalRemainCount: 1000,
      dadosGeraisResposta: {
        licitacaoId:null,
        conteudo:null,
        anexos:null
      }
    }
  },
  computed:{
    ehRecurso(){
      return this.tipoResposta === tipoRecursoContrarrazao.RECURSO
    },
    nenhumAnexoInserido(){
      return !this.dadosGeraisResposta.anexos || !this.dadosGeraisResposta.anexos.length > 0
    },
    mensagemConfirmacao(){
      if(this.nenhumAnexoInserido) {
        return 'Atenção, nenhum anexo foi inserido, deseja continuar?'
      }else{
        return 'Atenção, você está enviando uma resposta. Deseja continuar?'
      }
    }
  },
  methods: {
    fecharModal() {
      if(this.modalConfirmarEnvio){
        this.modalConfirmarEnvio = false
      }
      this.$emit('fecharModal')
    },
    contarTamanhoTexto(){
      this.totalRemainCount = this.maxTextArea - this.dadosGeraisResposta.conteudo.length;

      this.limiteTextoAtingido = this.totalRemainCount < 0;
      if(this.limiteTextoAtingido) this.dadosGeraisResposta.conteudo = this.dadosGeraisResposta.conteudo.slice(0, this.totalRemainCount)
    },
    naoContinuarSemAnexo(){
      this.modalConfirmarEnvio = false
    },
    async confirmarResposta() {
      this.modalConfirmarEnvio = true
    },
    async enviarResposta(){
      const dados = this.dadosGeraisResposta
      dados.licitacaoId = this.dadosLicitacao.id
      if(this.ehRecurso){
        dados.recursoId = this.dadosRecursoContrarrazao.id
        this.$emit('responderRecurso', dados)
      }else{
        dados.id = this.dadosRecursoContrarrazao.id
        this.$emit('responderContrarrazao', dados)
      }
    }
  }
}
</script>

<style lang="stylus">

.max-percent
  max-width 90%

.tabulacao-content
  margin-left 10px

.modal-title
  margin: 0
  padding: 10px 20px
  font-size: 18px !important
  color: white

.actions-modal
  border-top solid thin rgba(0, 0, 0, .12)
  padding-top 10px
  margin-top 0

&-conteudo
  min-height 350px

.container-header-text
  display flex
  flex-direction row
  justify-content center
  align-items center

.text-campo
  margin 0
  font-size 14px
  font-weight bold
  color #3A6861 !important

.textarea-conteudo-recurso
  padding-top 0 !important

  textarea
    padding 5px !important
    color #777 !important

  .v-input__slot
    border 1px solid #CCCCCC
    border-radius 5px

.select-analise
  margin 0 !important
  padding-top 0 !important
  .v-select__selections
    color #777 !important

.label
  font-size 14px
  font-weight bold
  color #3A6861 !important

.texto
  font-size 14px
  color #777 !important

.link-sem-decoracao a, a:link, a:hover, a:visited, a:active
  color: inherit
  text-decoration: none
</style>